import "antd/dist/reset.css";
import React, { useState } from "react";
import { Input, Button, Form, message, Alert } from "antd";
import axios from "axios";
import { CHANGE_PASSWORD } from "../../util";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [alert, setAlert] = useState(null); // State to store success/error message
  const userId = localStorage.getItem("userId");

  const handleSubmit = async (values) => {
    setLoading(true);
    setAlert(null); // Reset previous alerts

    try {
      const response = await axios.post(CHANGE_PASSWORD, {
        id: Number(userId),
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });

      if (response.data.status === 200) {
        setAlert({ type: "success", message: "Password Changed Successfully!" });
        form.resetFields();
      } else {
        setAlert({ type: "error", message: response.data.message || "Password Change Failed" });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message: error.response?.data?.message || "An error occurred while changing the password",
      });
    }

    setLoading(false);
  };

  return (
    <div style={{ marginTop: "16px", maxWidth: "400px", margin: "auto" }}>
      {alert && <Alert message={alert.message} type={alert.type} showIcon style={{ marginBottom: 16 }} />}

      <Form form={form} onFinish={handleSubmit}>
        <Form.Item name="oldPassword" rules={[{ required: true, message: "Please input your old password!" }]}>
          <Input.Password placeholder="Old Password" />
        </Form.Item>

        <Form.Item name="newPassword" rules={[{ required: true, message: "Please input your new password!" }]}>
          <Input.Password placeholder="New Password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Please confirm your new password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("The two passwords do not match!"));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm New Password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;
